import React, { useRef } from 'react';

import { Transition } from '@headlessui/react';
import { useRouter } from 'next/router';
import { useHover } from 'usehooks-ts';

const Tooltip = ({
  children,
  component,
}: {
  children: JSX.Element;
  component: JSX.Element;
}) => {
  const elRef = useRef<HTMLDivElement>(null);
  const hasHover = useHover(elRef);
  const router = useRouter();
  return (
    <span className="relative p-2 lg:p-0 inline-block" ref={elRef}>
      <div className="cursor-pointer">{children}</div>
      <Transition
        show={hasHover}
        as="div"
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-200"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <div
          className={`absolute shadow-xl  rounded-lg   ${
            router.pathname === '/services'
              ? 'translate-x-[-30%] translate-y-[-140%] mt-0 bg-white rounded-xl border '
              : 'translate-x-[-20%] mt-2 bg-white'
          } `}
        >
          {/* Pointing Arrow */}
          <div
            className={`absolute border-b-8  border-b-white border-l-8 border-l-transparent border-r-8 border-r-transparent    ${
              router.pathname === '/services'
                ? 'bottom-0 rotate-180 -mb-2 ml-[29%] border-b-neutral-100 '
                : 'top-0 -mt-2 ml-[20%]'
            } `}
          ></div>
          {/* Tooltip content */}
          {component}
        </div>
      </Transition>
    </span>
  );
};

export default Tooltip;
